import { actionTypes } from "../../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: [],
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ADD_MONEY_TO_WALLET_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.ADD_MONEY_TO_WALLET_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.ADD_MONEY_TO_WALLET_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.ADD_MONEY_TO_WALLET_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.ADD_MONEY_TO_WALLET_RESET_ALL:
            return initialState
        default:
            return state;
    }
};
